import { render, staticRenderFns } from "./AppGeneralFileViewer.vue?vue&type=template&id=5438accd&scoped=true"
import script from "./AppGeneralFileViewer.vue?vue&type=script&lang=js"
export * from "./AppGeneralFileViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5438accd",
  null
  
)

export default component.exports